import { useEffect, useState } from "react";
import FullListElements from "../../components/FullListElements/FullListElements";
import { ItemListElement } from "../../components/SortedItemsList/SortedItemsList";
import defaultAvatarImg from "../../img/defaultProfile.jpg";
import { CircularProgress } from "@mui/material";
import { TopUser } from "../../types/authTypes";
import { TopResponse } from "../../services/shirts/types";
import { useNavigate } from "react-router-dom";
import { COLLECTION_TAB } from "../MyProfile/MyProfile";
import { COLLECTION_SECTION } from "../MyProfile/Collection/Collection";

interface TopUsersProps {
  title: string;
  getUsersCall: Function;
  renderValue: Function;
}

const TopUsers = ({ title, getUsersCall, renderValue }: TopUsersProps) => {
  const [topUsers, setTopUsers] = useState<Array<TopUser> | undefined>(
    undefined
  );
  const [usersProcessed, setUsersProcessed] = useState<
    Array<ItemListElement> | undefined
  >(undefined);
  const [lastPage, setLastPage] = useState<number>(0);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);

  const navigate = useNavigate();

  const search = (page: number) => {
    getUsersCall(10, page).then((result: TopResponse) => {
      if (result) {
        setTopUsers(result.data as Array<TopUser>);
        setLastPage(result.lastPage);
        setTotalElements(result.total);
      }
    });
  };

  const goToResults = (id: string | number) => {
    navigate(
      "/my-profile/" +
        id +
        "/" +
        COLLECTION_TAB.COLLECTION +
        "/" +
        COLLECTION_SECTION.OVERVIEW
    );
  };

  useEffect(() => {
    getUsersCall(10, 1).then((result: TopResponse) => {
      if (result) {
        setTopUsers(result.data as Array<TopUser>);
        setLastPage(result.lastPage);
        setTotalElements(result.total);
      }
    });
  }, []);

  useEffect(() => {
    if (topUsers) {
      let userItems: Array<ItemListElement> = [];
      topUsers.forEach((user) => {
        userItems.push({
          id: user.id,
          name: user.username,
          value: user.item_count ? user.item_count : 0,
          profile_image: user.profile_image?.url,
        });
      });
      setUsersProcessed(userItems);
    }
  }, [topUsers]);

  return usersProcessed ? (
    <FullListElements
      elements={usersProcessed}
      title={title}
      defaultAvatarImg={defaultAvatarImg}
      searchByPage={search}
      renderValue={renderValue}
      lastPage={lastPage}
      totalElements={totalElements}
      handleOnClick={goToResults}
      itemsPerPage={itemsPerPage}
      setItemsPerPage={setItemsPerPage}
    />
  ) : (
    <CircularProgress />
  );
};

export default TopUsers;
